import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.search.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { i18n } from '@/boot/i18n';
import { FIB } from '@/config/constants';
var STAFF_FOLLOWUP_TYPE = FIB.STAFF_FOLLOWUP_TYPE;
export default {
  name: 'FibStaffSelection',
  props: {
    staff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filtersList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    followupType: {
      type: Number,
      default: STAFF_FOLLOWUP_TYPE.TAGS
    }
  },
  data: function data() {
    return {
      filterBy: 'all',
      isFilter: false,
      modals: [],
      modalWarning: false,
      search: '',
      searchBox: false,
      multiple: false,
      filteredStaff: [],
      selectedStaff: [],
      modalMember: null
    };
  },
  computed: {
    formattedTags: function formattedTags() {
      return this.tags.map(function (tag) {
        tag.label = tag.text;
        return tag;
      });
    },
    memberIsSelected: function memberIsSelected() {
      return !!this.modalMember;
    },
    bgImage: function bgImage() {
      return {
        backgroundImage: "url(".concat(this.$store.getters['theme/bgImage'], ")")
      };
    },
    answers: function answers() {
      return this.$store.getters['answers/responses'] || {};
    }
  },
  created: function created() {
    var _this = this;

    var staff = this.staff; // Type filtering

    if (this.filterBy !== 'all') {
      staff = staff.filter(function (s) {
        return s.type === _this.filterBy;
      });
    }

    this.filteredStaff = staff.map(function (member) {
      // Initialize to no follow up-questions.
      member.subQuestions = []; // Get the relevant tags for this staff member.

      var filteredTags = _this.formattedTags.filter(function (tag) {
        return tag.teamId == member.teamId;
      }); // Should a tag sub-question be posed?


      if ([STAFF_FOLLOWUP_TYPE.TAGS, STAFF_FOLLOWUP_TYPE.BOTH].includes(_this.followupType) && filteredTags.length) {
        member.subQuestions.push({
          question_type: 'staff_tag_question',
          handler: 'StaffTagQuestion',
          type: 'fib-select-option',
          props: {
            multiple: true,
            drillDownPlus: true,
            center: true,
            options: filteredTags
          }
        });
      } // Should a text sub-question be posed?


      if ([STAFF_FOLLOWUP_TYPE.TEXT, STAFF_FOLLOWUP_TYPE.BOTH].includes(_this.followupType)) {
        member.subQuestions.push({
          question_type: 'staff_text_question',
          handler: 'StaffTextQuestion',
          type: 'fib-comments',
          props: {
            label: i18n.t('questions.comments.enter'),
            rows: 4
          }
        });
      }

      return member;
    });
  },
  methods: {
    handleResponse: function handleResponse(value, questionHandler) {
      var _this2 = this;

      //update modalMember so that answers are displayed in the modal.
      var staffMember = cloneDeep(this.modalMember);
      var answers = this['handle' + questionHandler](value);
      staffMember.subQuestions.find(function (subQuestion) {
        return subQuestion.handler === questionHandler;
      }).answers = answers;
      this.modalMember = staffMember; //replace the filteredStaff member with the new modalMember

      var filteredStaff = cloneDeep(this.filteredStaff);
      var index = filteredStaff.findIndex(function (member) {
        return member.id === _this2.modalMember.id;
      });
      filteredStaff = this.replaceMember(filteredStaff, index, this.modalMember);
      this.filteredStaff = filteredStaff;
    },
    handleStaffTagQuestion: function handleStaffTagQuestion(values) {
      var _this3 = this;

      return values.map(function (value) {
        var id = _this3.tags.find(function (tag) {
          return tag.text === value;
        }).id;

        return {
          id: id,
          value: value
        };
      });
    },
    handleStaffTextQuestion: function handleStaffTextQuestion(values) {
      // Annoyingly, [] gets passed here on clear, which we'll recognize it as a clear by returning ''.
      return typeof values === 'string' ? values : '';
    },
    handleMemberClicked: function handleMemberClicked(member) {
      if (member.showModal && (member.subQuestions || []).length) {
        this.showMember(member);
      } else {
        // Remove the selected staff member if it's already selected, else select it.
        var index = this.selectedStaff.findIndex(function (m) {
          return m.id === member.id;
        });

        if (index >= 0) {
          this.selectedStaff.splice(index, 1);
          this.emitSelection();
        } else {
          this.toggleMemberSelected(member);
        }
      }
    },
    showMember: function showMember(member) {
      this.modalMember = member;
      this.openModal(member);
    },
    toggleMemberSelected: function toggleMemberSelected(member) {
      // Clone selectedStaff to avoid directly mutating the Vuex state
      var selectedStaff = cloneDeep(this.selectedStaff);
      var index = selectedStaff.indexOf(member.id);
      selectedStaff = this.replaceMember(selectedStaff, index, member);
      this.selectedStaff = selectedStaff;
      this.emitSelection();
    },
    replaceMember: function replaceMember(staff, index, member) {
      if (index !== -1) {
        staff[index] = member;
      } else {
        // If we're only allowing a single selection, we should empty out the list before adding.
        if (!this.multiple) {
          staff = [member];
        } else {
          staff.push(member);
        }
      }

      return staff;
    },
    emitSelection: function emitSelection() {
      this.$emit('input', cloneDeep(this.selectedStaff));
    },
    findSubQuestionOnStaff: function findSubQuestionOnStaff(member, key, identifier) {
      return member.subQuestions.find(function (subQuestion) {
        return subQuestion[key] === identifier;
      });
    },
    getSubQuestionAnswer: function getSubQuestionAnswer(item, questionHandler) {
      var answerHandler = 'get' + questionHandler + 'Answer';
      var subQuestion = this.findSubQuestionOnStaff(item, 'handler', questionHandler);
      return this[answerHandler](subQuestion);
    },
    getStaffTagQuestionAnswer: function getStaffTagQuestionAnswer(subQuestion) {
      var answers = subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.answers;

      if (!answers) {
        return [];
      }

      return answers.map(function (answer) {
        return answer.value;
      });
    },
    getStaffTextQuestionAnswer: function getStaffTextQuestionAnswer(subQuestion) {
      return (subQuestion === null || subQuestion === void 0 ? void 0 : subQuestion.answers) || '';
    },
    openModal: function openModal(member) {
      this.$set(this.modals, member.id, true);
    },
    submitModal: function submitModal(item, check) {
      var dirty = this.isDirty(item);
      this.modalMember = null;

      if (check && dirty) {
        this.modalWarning = true;
        return;
      }

      this.toggleMemberSelected(item);
      this.$set(this.modals, item.id, false);
    },
    closeWithoutSave: function closeWithoutSave() {
      var _this4 = this;

      var item = this.staff.find(function (i) {
        return i.name === _this4.modalMember.name;
      });
      this.clearModal(item);
      this.modalWarning = false;
    },
    buttonDisabled: function buttonDisabled(item) {
      var _this5 = this;

      var subQuestions = item.subQuestions;
      var disabled = false;

      if (subQuestions) {
        disabled = subQuestions.some(function (subQuestion) {
          return subQuestion.required && !_this5.answers[subQuestion.id];
        });
      }

      return disabled;
    },
    isDirty: function isDirty(item) {
      var subQuestions = item.subQuestions;
      var dirty = false;

      if (subQuestions) {
        dirty = subQuestions.some(function (subQuestion) {
          return !(subQuestion !== null && subQuestion !== void 0 && subQuestion.answers);
        });
      }

      if (!item.showModal) {
        dirty = this.selectedStaff.some(function (member) {
          return member === item.id;
        });
      }

      return dirty;
    },
    clearModal: function clearModal(item) {
      var _this6 = this;

      var subQuestions = item.subQuestions;

      if (subQuestions) {
        subQuestions.forEach(function (subQuestion) {
          return _this6.handleResponse([], subQuestion.handler);
        });
      }

      this.modalMember = null;
      var index = this.selectedStaff.findIndex(function (member) {
        return member.id === item.id;
      });

      if (index >= 0) {
        this.selectedStaff.splice(index, 1);
      }

      this.emitSelection();
    },
    avatarIsSelected: function avatarIsSelected(item) {
      return this.selectedStaff.some(function (member) {
        return member.id === item.id;
      });
    },
    searchStaff: function searchStaff() {
      var search = (this.search || '').trim().toLowerCase();
      this.filteredStaff = this.staff.filter(function (s) {
        return ((s === null || s === void 0 ? void 0 : s.name) || '').toLowerCase().includes(search);
      });
    }
  }
};